import common from './common';
import application from './application';
import loan from './loan';
import privy from './privy';
import sentry from './sentry';
import ga from './ga';

const services = {};

services.common = common;
services.application = application;
services.loan = loan;
services.privy = privy;
services.sentry = sentry;
services.ga = ga;

export default services;
